import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { HttpService } from './http.service';
import { LocalStorageService } from './local-storage.service';
import { HttpClient } from '@angular/common/http';
import { TranslateConfigService } from '@src/app/core/services/translate-config.service';
import { SharedDataService } from './shared-data.service';
@Injectable({
  providedIn: 'root'
})
export class TranslationDataService implements Resolve<any> {

  constructor(private sharedService: SharedDataService, private apiService: HttpClient, private localStorageService: LocalStorageService, private translateConfigService: TranslateConfigService) { }
  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let jsonPath = route.data['languageFilePath'] + this.getCurrentLanguageCode() + '.json';
    this.translateConfigService.setPath(route.data['languageFilePath']);
    const translationData = await this.apiService.get(jsonPath).toPromise();
    this.localStorageService.set({
      key: 'languageOptimization',
      value: { path: jsonPath, languagedata: translationData },
    });
    if (route.data['isSubDomain']) {
      try {
        let jsonPath = route.data['languageFilePath'] + this.sharedService.tenantName +'/' + this.getCurrentLanguageCode() + '.json';
        const translationData = await this.apiService.get(jsonPath).toPromise();
        this.localStorageService.set({
          key: 'subLanguageOptimization',
          value: { path: jsonPath, languagedata: translationData },
        });
      }
      catch (err) {
        this.localStorageService.remove('subLanguageOptimization')
      }
    }
  }
  private getCurrentLanguageCode(): string {
    const storedLanguage = this.localStorageService.get('language');
    return storedLanguage ? storedLanguage.code : 'en';
  }
}
